.notice,
.prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.notice {
  margin-top: 8px;
  padding: 28px 20px 20px;
  background: var(--hero-bg);
  border: 1px solid var(--card-border);
  border-radius: var(--r-xl);
}

.badge {
  display: inline-grid;
  place-items: center;
  width: 64px;
  height: 64px;
  color: var(--ink);
  background: var(--accent-wash);
  border: 1px solid var(--card-border);
  border-radius: 50%;
}

.title {
  margin-top: 14px;
  font-size: 20px;
  font-weight: 700;
}

.text {
  margin: 10px 4px 18px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--muted);
}

.prompt .text {
  margin-top: 14px;
}

.perks {
  align-self: stretch;
  margin: 0 0 18px;
  padding: 0;
  list-style: none;
  text-align: left;
}

.perks li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 4px;
  font-size: 14px;
}

.perks li :global(svg) {
  flex: 0 0 auto;
  color: var(--ok);
}
